export default __webpack_public_path__ + "static/media/mracho.8033ff98.webp";